import { render, staticRenderFns } from "./ExemptionApply.vue?vue&type=template&id=65f96c44"
import script from "./ExemptionApply.vue?vue&type=script&lang=js"
export * from "./ExemptionApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports